import { Web2PublishMain } from 'components/Web2Publish/components/Main';

const ScreenWeb2PublishMain = () => {
  return <Web2PublishMain />;
};

export default ScreenWeb2PublishMain;
